<template>
    <div class="card shadow h-100">
        <div class="card-header text-center bg-primary">
            Nouveaux commentaires
        </div>
        <div class="card-body p-0">
            <div class="comments-container">
                <div v-if="comments.length > 0">
                    <div v-for="comment in comments" :key="comment.id">
                        <b-card
                            bg-variant="light"
                            no-body
                            class="text-dark p-2 mb-3 shadow-sm"
                        >
                            <b-link
                                title="Accéder à la fiche client"
                                @click="goToClientHome(comment.client.uuid)"
                            >
                                <p class="comment-client">
                                    {{ comment.client.name }}
                                </p>
                            </b-link>
                            <p class="comment-created">
                                {{ comment.type.name }} :
                                <span class="font-italic"
                                    >{{ comment.created_at_for_humans }} par
                                    {{ comment.created_by.name }}</span
                                >
                            </p>
                            <hr class="mb-1 mt-1" />
                            <p class="comment-description">
                                {{ comment.description }}
                            </p>
                        </b-card>
                    </div>
                </div>
                <div v-else>
                    <b-card
                        bg-variant="light"
                        no-body
                        class="text-dark p-2 mb-3 shadow-sm"
                    >
                        <p class="comment-description">
                            Aucun nouveau commentaire n'a été rédigé sur vos
                            clients
                        </p>
                    </b-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HomeNewComments',

    data() {
        return {
            comments: [],
        }
    },

    async created() {
        await this.getComments()
    },

    methods: {
        async getComments() {
            try {
                const response = await this.$axios.get('/history/home')
                this.comments = response.data.data
            } catch (error) {
                error.log(error)
            }
        },

        goToClientHome(uuid) {
            window.location.href = `pilotage-activite/clients/${uuid}/accueil`
        },
    },
}
</script>

<style scoped>
.comments-container {
    background-color: white !important;
    padding: 15px;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 562px;
}

.comment-client {
    font-weight: bold;
    margin-bottom: 0;
    margin-top: 0;
}

.comment-description {
    margin-bottom: 0;
}

.comment-created {
    font-size: 11px;
    margin-bottom: 0;
}
</style>
